import { usePlanningDateRange } from '../../../hooks/use-get-path-helpers';

export const useGetVisibleDays = () => {
  const { startDate, endDate } = usePlanningDateRange();
  const diff = endDate.diff(startDate, 'days').toObject().days ?? 0;
  const visibleDays = Array(diff + 1)
    .fill(null)
    .map((_, i) => startDate.plus({ days: i }).toISO());

  return { visibleDays };
};
